
<div class="block w-full h-[20rem] md:h-[33rem] dark-overlay animate-pulse relative shadow-sm">
    <div class="h-12 w-full bg-white flex md:hidden justify-between px-8 items-center relative z-10">
        <iho-skeleton height="1.5rem" width="3rem" />
        <iho-skeleton height="1.5rem" width="6rem" />
        <iho-skeleton height="1.5rem" width="4rem" />
    </div>

    <div class="hidden md:flex flex-col gap-4 items-center container relative top-36">
        <iho-skeleton height="3.5rem" width="20rem" />
        <iho-skeleton height="2rem" width="25rem" />
    </div>

    <div class="md:hidden flex flex-col gap-2 container relative top-10">
        <iho-skeleton height="2.5rem" width="12rem" />
        <iho-skeleton height="2.5rem" width="16rem" />
    </div>


    <!-- searchbox -->

    <div class="container">
        <!-- desktop searchbox -->
        <div class="container absolute -bottom-[8.5rem] md:-bottom-16 left-0 right-0 z-10 md:h-48 h-[15rem]">
            <div class="
                flex flex-col gap-2 md:gap-6 md:pt-9 pt-3
                h-full w-full bg-white rounded-2xl border border-solid overflow-hidden shadow-sm">

                <div class="flex items-center gap-2 w-full md:w-80 px-6">
                    <iho-skeleton height="3rem" class="flex-grow w-full" />
                    <iho-skeleton height="3rem" class="flex-grow w-full" />
                </div>

                <div class="flex flex-col items-center md:grid md:grid-cols-5 px-6 gap-2">
                    <iho-skeleton height="3rem" class="w-full md:col-span-2" />
                    <iho-skeleton height="3rem" class="w-full md:col-span-2" />
                    <iho-skeleton height="3rem" class="w-full md:col-span-1" />
                </div>
            </div>
        </div>

    </div>
</div>